import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-16">
            <div>
              <h3 className="text-4xl md:text-5xl font-bold font-heading mb-8">{siteInfo.logo}</h3>
              <p className="text-sm text-background-50/60 leading-relaxed max-w-xs mb-6">
                {siteInfo.description}
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors duration-200" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors duration-200" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors duration-200" aria-label="抖音">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors duration-200" aria-label="B站">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-widest text-background-50/40 font-medium mb-6">联系方式</h4>
              <div className="space-y-5">
                <div>
                  <p className="text-sm text-background-50/50 mb-1">投稿邮箱</p>
                  <p className="text-sm text-background-50/80">{siteInfo.email}</p>
                </div>
                <div>
                  <p className="text-sm text-background-50/50 mb-1">微信公众号</p>
                  <p className="text-sm text-background-50/80">{siteInfo.wechat}</p>
                </div>
                <div>
                  <p className="text-sm text-background-50/50 mb-1">官方微博</p>
                  <p className="text-sm text-background-50/80">{siteInfo.weibo}</p>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-widest text-background-50/40 font-medium mb-6">热门分类</h4>
              <div className="grid grid-cols-2 gap-3">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {currentYear} {siteInfo.name} 版权所有
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors duration-200">关于我们</Link>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors duration-200">隐私政策</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors duration-200">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}